import { defineMessages } from 'react-intl'

export default defineMessages({
  nameLabel: {
    id: 'LegalEntityForm.nameLabel',
    defaultMessage: 'Entity name',
  },
  namePlaceholder: {
    id: 'LegalEntityForm.namePlaceholder',
    defaultMessage: 'Enter entity name',
  },
  nameRequiredError: {
    id: 'LegalEntityForm.nameRequiredError',
    defaultMessage: 'Enter an entity name to continue',
  },
  nameDuplicateError: {
    id: 'LegalEntityForm.nameDuplicateError',
    defaultMessage: 'This name is taken. Try a different one.',
  },
  countryLabel: {
    id: 'LegalEntityForm.countryLabel',
    defaultMessage: 'Country',
  },
  countryRequiredError: {
    id: 'LegalEntityForm.countryRequiredError',
    defaultMessage: 'Select a country to continue',
  },
  externalIdLabel: {
    id: 'LegalEntityForm.externalIdLabel',
    defaultMessage: 'External ID (Optional)',
  },
  externalIdTooltip: {
    id: 'LegalEntityForm.externalIdTooltip',
    defaultMessage:
      'The ID that links this entity to its matching record in your ERP.',
  },
  externalIdMaxLengthError: {
    id: 'LegalEntityForm.externalIdMaxLengthError',
    defaultMessage: 'External ID must be 100 characters or fewer',
  },
  externalIdDuplicateError: {
    id: 'LegalEntityForm.externalIdDuplicateError',
    defaultMessage: 'This external ID is taken. Try a different one.',
  },
  baseCurrencyLabel: {
    id: 'LegalEntityForm.baseCurrencyLabel',
    defaultMessage: 'Base currency',
  },
  baseCurrencyRequiredError: {
    id: 'LegalEntityForm.baseCurrencyRequiredError',
    defaultMessage: 'Select a currency to continue',
  },
  baseCurrencyTooltip: {
    id: 'LegalEntityForm.baseCurrencyTooltip',
    defaultMessage: 'Select from the active currency list',
  },
  manageCurrencyLink: {
    id: 'LegalEntityForm.manageCurrencyLink',
    defaultMessage: 'Manage currency list',
  },
  inboxSectionHeader: {
    id: 'LegalEntityForm.inboxSectionHeader',
    defaultMessage: 'Invoice inbox address',
  },
  inboxSectionDescription: {
    id: 'LegalEntityForm.inboxSectionDescription',
    defaultMessage:
      'Invoices emailed to this address become draft bills for this entity.',
  },
  inboxHandleLabel: {
    id: 'LegalEntityForm.inboxHandleLabel',
    defaultMessage: 'Inbox name',
  },
  inboxHandleTip: {
    id: 'LegalEntityForm.inboxHandleTip',
    defaultMessage: 'Tip: Use something short that your team will recognize.',
  },
  inboxHandleRequiredError: {
    id: 'LegalEntityForm.inboxHandleRequiredError',
    defaultMessage: 'Enter an inbox name to continue',
  },
  inboxHandleFormatError: {
    id: 'LegalEntityForm.inboxHandleFormatError',
    defaultMessage: 'Use only lowercase letters, numbers, and hyphens',
  },
  inboxHandleCharacterCount: {
    id: 'LegalEntityForm.inboxHandleCharacterCount',
    defaultMessage: '({count}/{max})',
  },
  inboxAddressRecap: {
    id: 'LegalEntityForm.inboxAddressRecap',
    defaultMessage: 'Your address will be {address}',
  },
  cancelButton: {
    id: 'LegalEntityForm.cancelButton',
    defaultMessage: 'Cancel',
  },
  createButton: {
    id: 'LegalEntityForm.createButton',
    defaultMessage: 'Create',
  },
})
